import { Int } from '@adornis/baseql/baseqlTypes';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { context } from '@adornis/baseql/server/context';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { checkPermission } from '../../permissions/helpers';
import { FileFilter } from '../db/FileFilter';
import { Folder } from '../db/Folder';
import { LASFile } from '../db/LASFile';
import type { MediaUnion } from '../db/MediaUnion';
import { BaseQLMediaUnion } from '../db/MediaUnion';

export const getFilesPaginatedFiltered = registerQuery({
  type: () => [BaseQLMediaUnion],
  operationName: 'getFilesPaginatedFiltered',
  resolve: (skip: number, limit: number, filter: FileFilter) => {
    return async (gqlFields: BaseQLSelectionSet<MediaUnion>) => {
      await checkPermission({ context, permission: 'Designer.View' });
      const rawFilesCollection = await getRawCollection<LASFile>(LASFile._collectionName);
      const preAggregate: any[] = [];
      if ((filter.fileExtensions?.length ?? 0) > 0) {
        preAggregate.push({
          $match: { $or: [{ 'meta.extension': { $in: filter.fileExtensions } }, { _class: Folder._class }] },
        });
      }
      if (filter.fileName) {
        preAggregate.push({
          $match: {
            $or: [
              {
                $and: [
                  { 'meta.fileName': { $regex: `${filter.fileName}`, $options: 'i' } },
                  { _class: LASFile._class },
                ],
              },
              {
                $and: [{ name: { $regex: `${filter.fileName}`, $options: 'i' } }, { _class: Folder._class }],
              },
            ],
          },
        });
      }

      if (filter.md5) {
        preAggregate.push({ $match: { 'meta.md5': filter.md5 } });
      }

      if (filter.parentFolderID !== '') {
        if (filter.parentFolderID) {
          preAggregate.push({ $match: { parentFolderID: filter.parentFolderID } });
        } else if (!filter.fileName) {
          preAggregate.push({
            $match: {
              $or: [{ parentFolderID: { $exists: false } }, { parentFolderID: null }],
            },
          });
        }
      }

      console.log(preAggregate);

      const unionResult = await rawFilesCollection
        .aggregate<MediaUnion>([
          {
            $unionWith: Folder._collectionName,
          },
          ...preAggregate,
          {
            $sort: {
              _class: 1, // Ordner (_class: Folder._class) werden zuerst angezeigt
              createdAt: -1,
            },
          },
          ...(skip === -1 ? [] : [{ $skip: skip }]),
          ...(limit === -1 ? [] : [{ $limit: limit }]),
        ])
        .toArray();

      return unionResult;
    };
  },
  params: [
    { name: 'skip', type: () => Int },
    { name: 'limit', type: () => Int },
    { name: 'filter', type: () => FileFilter },
  ],
});
